"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registeredCharityNumberSchema = void 0;
var _zod = require("zod");
var registeredCharityNumberSchema = t => {
  return _zod.z.object({
    charityNumber: _zod.z.string().min(1, {
      message: t('payApplication.payapp.memorable.error')
    })
  });
};
exports.registeredCharityNumberSchema = registeredCharityNumberSchema;